import { ReactNode } from "react";

import * as theme from "./ApplicationBarHeader.css";
import {
    ApplicationBarVariant,
    ApplicationBarVariantContext,
} from "./ApplicationBarVariant";

export interface ApplicationBarHeaderProps {
    /**
     * `flat` is white with a divider below instead of a shadow. The header row,
     * breadcrumbs, profile and `ApplicationBarToolbar` inside take the same
     * variant. Defaults to `default`.
     */
    variant?: ApplicationBarVariant;
    /**
     * The header row, followed by the `ApplicationBarToolbar` if the page has one.
     */
    children: ReactNode;
}

export function ApplicationBarHeader({
    variant = "default",
    children,
}: ApplicationBarHeaderProps) {
    return (
        <header className={theme.header[variant]}>
            <ApplicationBarVariantContext.Provider value={variant}>
                {children}
            </ApplicationBarVariantContext.Provider>
        </header>
    );
}
